var map = {
	"./college-intro-bg1.png": 407,
	"./college-intro-bg2.png": 6295,
	"./college-intro-bg3.png": 2803,
	"./college-intro-icon.png": 1606,
	"./college-intro-icon2.png": 3037,
	"./college-intro-img.png": 4020,
	"./college-intro-img2.png": 1080,
	"./college-intro-img3.png": 201,
	"./college-intro.png": 6650,
	"./footer-bg.png": 1243,
	"./footer-bg2.png": 882,
	"./footer-icon1.png": 559,
	"./footer-icon2.png": 509,
	"./footer-icon3.png": 8379,
	"./footer-icon4.png": 6353,
	"./introduce-mode.png": 7505,
	"./introduce-need.png": 5646,
	"./introduce-type-bg.png": 4902,
	"./introduce-type-content-bg.png": 6537,
	"./introduce-type-tab-bg.png": 5203,
	"./introduce-type.png": 5472,
	"./introduceMode/kjljrc.png": 9116,
	"./introduceMode/qnbsrc.png": 3413,
	"./introduceMode/qnkjyc.png": 7955,
	"./introduceMode/xkbjrc.png": 5134,
	"./introduceMode/xsxxrc.png": 5044,
	"./introduceMode/yxssrc.png": 8956,
	"./introduceType/kjljrc-red.png": 665,
	"./introduceType/kjljrc-white.png": 3801,
	"./introduceType/qnbsrc-red.png": 7606,
	"./introduceType/qnbsrc-white.png": 6467,
	"./introduceType/qnkjyc-red.png": 3136,
	"./introduceType/qnkjyc-white.png": 9710,
	"./introduceType/xkbjrc-red.png": 438,
	"./introduceType/xkbjrc-white.png": 8563,
	"./introduceType/xsxxrc-red.png": 3087,
	"./introduceType/xsxxrc-white.png": 6023,
	"./introduceType/yxssrc-red.png": 4777,
	"./introduceType/yxssrc-white.png": 1245,
	"./introduceType2/kjljrc-red.png": 6972,
	"./introduceType2/kjljrc-white.png": 9776,
	"./introduceType2/qnbsrc-red.png": 1593,
	"./introduceType2/qnbsrc-white.png": 4825,
	"./introduceType2/qnkjyc-red.png": 2993,
	"./introduceType2/qnkjyc-white.png": 8599,
	"./introduceType2/xkbjrc-red.png": 7743,
	"./introduceType2/xkbjrc-white.png": 9015,
	"./introduceType2/xsxxrc-red.png": 4980,
	"./introduceType2/xsxxrc-white.png": 8355,
	"./introduceType2/yxssrc-red.png": 3704,
	"./introduceType2/yxssrc-white.png": 9174,
	"./logo.png": 6949,
	"./qr-code.png": 837,
	"./school-condition-bg.png": 7604,
	"./school-condition.png": 138,
	"./science-grade-bg.png": 2974,
	"./science-grade.png": 8430,
	"./team-intro-bg.png": 9841,
	"./team-intro.png": 9518,
	"./title_bg.png": 1903,
	"./treatment-standard-bg.png": 7318,
	"./treatment-standard.png": 1879,
	"./treatmentStandard/bsh.png": 3328,
	"./treatmentStandard/gkzkwzry.png": 4938,
	"./treatmentStandard/htjzyj.png": 7995,
	"./treatmentStandard/htpy.png": 394,
	"./treatmentStandard/htzzyj.png": 2739,
	"./treatmentStandard/tzrw.png": 6203,
	"./treatmentStandard/zjxbzljg.png": 7314,
	"./treatmentStandard/zjyjwzry.png": 1438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;